export default __webpack_public_path__ + "static/media/email-icon.bf5509b2.svg";